import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ServicePage from "@/pages/ServicePage";

export const Route = createFileRoute("/es/servicios/clinical-solutions/")({
  head: () => buildRouteHead("/es/servicios/clinical-solutions"),
  component: ServicePage,
});

